import React, { Fragment, memo } from 'react';
import FETCH from '../Fetch';
import { Link } from 'react-router-dom';
import TransactionHistoryLoader from '../loaderComponents/TransactionHistoryLoader';
import { toast } from './Notifier';
import { numberFormat } from '../utils';
import NetworkError from './NetworkError';

const EmptyTransactions = memo(props => (
  <div class="card-body">
    <div class="dashboard-transaction-container">
      <div class="empty-card text-center mt-3">
        <button class="circle-bg-width-80 circle-bg circle-bg-gray">
          <img
            src={require('../assets/empty-fee.svg')}
            class="svg"
            alt="Min Unit"
          />
        </button>
        <p>No Transactions</p>
        <small>You Have Not Made Any Transactions Yet</small>
      </div>
    </div>
  </div>
));

class TransactionHistory extends React.Component {
  state = {
    transactionhistoryData: null
  };

  componentDidMount() {
    // get data from API
    // fetch transaction details
    FETCH.getTransactionHistory()
      .then(res => {
        if (res.status !== 'success') {
          this.setState({ networkError: true });
          return;
        }
        if (res.message === 'You have not made any transaction') {
          this.setState({ transactionData: 'empty' });
          return;
        }
        this.setState({ transactionhistoryData: res.data });
      })
      .catch(error => {
        toast('Could not get transaction history, check network connectivity', {
          status: 'error'
        });
      });
  }

  interpretePaymentStatus = status => {
    
    // interprete payment status codes
    let meaning = {};
    switch (status) {
      case '0':
        meaning.text = 'Pending';
        meaning.id = 'pending';
        break;
      case '100':
        meaning.text = 'Pending';
        meaning.id = 'pending';
        break;
      case '00':
        meaning.text = 'Success';
        meaning.id = 'success';
        break;
      case '01':
        meaning.text = 'Success';
        meaning.id = 'success';
        break;
      case '02':
        meaning.text = 'Failed';
        meaning.id = 'failed';
        break;
      case '023':
        meaning.text = 'Failed';
        meaning.id = 'failed';
        break;
      case '012':
        meaning.text = 'Aborted';
        meaning.id = 'aborted';
        break;
      case '021':
        meaning.text = 'Pending';
        meaning.id = 'pending';
        break;
      case '026':
        meaning.text = 'No such order';
        meaning.id = 'No such order';
        break;
      default:
        meaning.text = 'Failed';
    }

    return meaning;
  };

  render() {
    return this.state.networkError ? (
      <NetworkError
        networkError=""
        message="Your transactions are not available, try again later"
      />
    ) : (
      <Fragment>
        <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
          <h1>My Transactions</h1>
          {/* card for transaction history  */}
          <div className="row no-gutters">
            <div className="col-lg-12">
              <div className="card min-h-700">
                <div className="card-header">
                  <div className="row no-gutters">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 pt-3">
                      Transaction History
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                      <button className="btn btn-solid" disabled={true}>
                        {/*this.state.transactionData === 'empty'*/}
                        <i className="fas fa-print mr-1" /> Print History
                      </button>
                    </div>
                  </div>
                </div>
                {this.state.transactionData !== 'empty' ? (
                  <div className="card-body p-0 m-0">
                    <div className="table-responsive">
                      <table className="table transaction-history">
                        <thead>
                          <tr>
                            <th scope="col" width={200} className="pl-41">
                              Fee Type
                            </th>
                            <th scope="col" width={80}>
                              Amount
                            </th>
                            <th scope="col" width={80}>
                              Status
                            </th>
                            <th scope="col" width={150}>
                              Date
                            </th>
                            <th scope="col" width={100}>
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.transactionhistoryData ? (
                            this.state.transactionhistoryData.map(
                              transactionItem => (
                                <TransactionDetail
                                  description={transactionItem.description}
                                  amount={numberFormat(
                                    transactionItem.total_amount
                                  )}
                                  statusDescription={
                                    this.interpretePaymentStatus(
                                      transactionItem.payment_status
                                    ).text
                                  }
                                  btnId={
                                    this.interpretePaymentStatus(
                                      transactionItem.payment_status
                                    ).id
                                  }
                                  //  use date_completed is transaction is successfull, and date_performed if otherwise
                                  date={
                                    transactionItem.payment_status === '01'
                                      ? transactionItem.date_completed
                                      : transactionItem.date_completed
                                  }
                                  key={transactionItem.description}
                                  transaction_id={
                                    transactionItem.transaction_id
                                  }
                                />
                              )
                            )
                          ) : (
                            <>
                              <TransactionHistoryLoader />
                              <TransactionHistoryLoader />
                              <TransactionHistoryLoader />
                              <TransactionHistoryLoader />
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <EmptyTransactions />
                )}
              </div>
              {/* card for transaction history */}
            </div>
          </div>
          {/* end card for news display   */}
        </main>
      </Fragment>
    );
  }
}

const TransactionDetail = memo(props => (
  <tr>
    <td className="pl-41 text">{props.description}</td>
    <td className="text">{props.amount} NGN</td>
    <td>
      <span className="transaction-status" id={props.btnId}>
        {props.statusDescription}
      </span>
    </td>
    <td className="text-thin">{props.date}</td>
    <td className="p-28-0">
      <Link
        to={`/transaction/details/${props.transaction_id}`}
        className="btn btn-lg course-action-btn active"
      >
        View
      </Link>
    </td>
  </tr>
));

export default TransactionHistory;
